require('new_design/common/main_slider_camp_site');
